// src/components/UploadWorkspace/uploadlocalWorkspace.js

import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { videoStorage } from '../../../../firebase';
// FUNCTIONS
import { captionsBumpFunctionFor } from '../../../../myStudio/myBumpUp/captionsFunctions';

// Function to validate the video file
const validateFile = (file) => {
    return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        video.preload = 'metadata';

        video.onloadedmetadata = () => {
            window.URL.revokeObjectURL(video.src);
            if (video.duration > 0 && video.videoWidth > 0 && video.videoHeight > 0) {
                let videoQuality;
                if (video.videoWidth >= 3840) {
                    videoQuality = '4K';
                } else if (video.videoWidth >= 1920) {
                    videoQuality = 'HD';
                } else if (video.videoWidth >= 1280) {
                    videoQuality = '720';
                } else {
                    videoQuality = 'SD';
                }
                resolve({ videoQuality, videoDuration: video.duration });
            } else {
                reject('Invalid video file');
            }
        };

        video.onerror = () => {
            window.URL.revokeObjectURL(video.src);
            reject('Invalid video file');
        };

        video.src = URL.createObjectURL(file);
    });
};
const uploadlocalWorkspace = async (
    file,
    user,
    content_id,
    setUploadProgress,
    setShowPopup,
    storagePathRef,
    uploadTaskRef,
    onSuccess,
    onBeforeCaption
) => {
    if (!file) return;

    // Check if the file size exceeds the maximum allowed size (31GB)
    if (file.size > 31 * 1024 * 1024 * 1024) {
        console.error("File size exceeds the 31GB limit:", file.size);
        return;
    }

    let videoMetadata;
    try {
        videoMetadata = await validateFile(file);
    } catch (validationError) {
        return;
    }

    // Show the upload popup
    setShowPopup(true);

    // Define metadata for the video file
    const metadata = {
        contentType: file.type,
        customMetadata: {
            uploadedBy: user.uid,
            description: 'Video upload',
            videoFileName: file.name,
            videoQuality: videoMetadata.videoQuality,
            videoDuration: videoMetadata.videoDuration.toString(),
            contentId: `workspace-${content_id}` 
        }
    };

    // Create a storage reference using content_id
    const storageRef = ref(videoStorage, `${user.uid}/workspace-${content_id}`);
    storagePathRef.current = storageRef;

    // Start the upload task
    const uploadTask = uploadBytesResumable(storageRef, file, metadata);
    uploadTaskRef.current = uploadTask;

    // Monitor the upload progress
    uploadTask.on('state_changed',
        (snapshot) => {
            const videoProgress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
            setUploadProgress(videoProgress);


        },
        (error) => {
        },
        async () => {
            // Declared here so catch block can reference it for the timeout error path
            let effectiveContentId = content_id;
            try {
                // Get the download URL after successful upload
                await getDownloadURL(uploadTask.snapshot.ref);

                // Update upload progress to 100%
                setUploadProgress(100);

                // Create the workspace in Firestore now (deferred until after successful upload)
                if (onBeforeCaption) {
                    try {
                        const resolved = await onBeforeCaption(content_id);
                        if (resolved) effectiveContentId = resolved;
                    } catch {
                        return;
                    }
                }

                // Prepare the payload for the captions bump function
                const payload = {
                    videoMetadata: {
                        uploadedBy: user.uid,
                        contentId: `workspace-${effectiveContentId}`, // Changed from videoId to content_id
                        description: 'Video upload',
                        videoFileName: file.name,
                        videoQuality: videoMetadata.videoQuality,
                        videoDuration: videoMetadata.videoDuration.toString()
                    }
                };
                
                // Fire the captions function and redirect immediately — processing continues on the server
                captionsBumpFunctionFor(file.size, videoMetadata.videoDuration)(payload);
                if (onSuccess) onSuccess();

            } catch (error) {
            }
            
            
        }
    );
};

export { uploadlocalWorkspace, validateFile };
